export const ROUTE_VIEW_MAP = {
  '/WorkScheduleTable': 'work_schedule',
  '/DeliveryChallanTable': 'delivery_challan',
  '/DesignMixTable': 'design_mix',
  '/GoodsReceiptNoteTable': 'goods_receipt_note',
  '/QuotationTable': 'quotation',
  '/PurchaseOrderTable': 'purchase_order',
  '/SalesOrderTable': 'sales_order',
  '/CheckInTable': 'check_in',
};

export const DATE_RANGE_OPTIONS = {
  today: { label: 'Today' },
  current_month: { label: 'Current Month' },
  last_two_months: { label: 'Last Two Months' },
  last_three_months: { label: 'Last Three Months' },
  custom: { label: 'Custom Date Range' },
};

export const LIST_VIEW_SCHEMAS = {
  work_schedule: {
    sectionTitle: 'Work Schedule View',
    toolbarDateRanges: ['today', 'current_month', 'last_two_months', 'custom'],
    dateRangeOptions: [
      { value: 'today', label: 'Today' },
      { value: 'current_month', label: 'Current Month' },
      { value: 'last_two_months', label: 'Last Two Months' },
      { value: 'custom', label: 'Custom Date Range' },
    ],
    statusOptions: [
      { value: 'not_started', label: 'Not Started' },
      { value: 'in_progress', label: 'In-Progress' },
      { value: 'to_complete', label: 'To Complete' },
      { value: 'completed', label: 'Completed' },
    ],
    recordStatusOptions: [
      { value: 'true', label: 'Active' },
      { value: 'false', label: 'In-Active' },
    ],
  },
  delivery_challan: {
    sectionTitle: 'Delivery Challan View',
    toolbarDateRanges: ['today', 'current_month', 'last_three_months', 'custom'],
    dateRangeOptions: [
      { value: 'today', label: 'Today' },
      { value: 'current_month', label: 'Current Month' },
      { value: 'last_three_months', label: 'Last Three Months' },
      { value: 'custom', label: 'Custom Date Range' },
    ],
  },
  design_mix: {
    sectionTitle: 'Design Mix View',
    toolbarDateRanges: ['today', 'current_month', 'last_three_months', 'custom'],
    dateRangeOptions: [
      { value: 'today', label: 'Today' },
      { value: 'current_month', label: 'Current Month' },
      { value: 'last_three_months', label: 'Last Three Months' },
      { value: 'custom', label: 'Custom Date Range' },
    ],
  },
  goods_receipt_note: {
    sectionTitle: 'Goods Receipt Note View',
    toolbarDateRanges: ['today', 'current_month', 'last_three_months', 'custom'],
    dateRangeOptions: [
      { value: 'today', label: 'Today' },
      { value: 'current_month', label: 'Current Month' },
      { value: 'last_three_months', label: 'Last Three Months' },
      { value: 'custom', label: 'Custom Date Range' },
    ],
  },
  quotation: {
    sectionTitle: 'Quotation View',
    toolbarDateRanges: ['today', 'current_month', 'last_three_months', 'custom'],
    dateRangeOptions: [
      { value: 'today', label: 'Today' },
      { value: 'current_month', label: 'Current Month' },
      { value: 'last_three_months', label: 'Last Three Months' },
      { value: 'custom', label: 'Custom Date Range' },
    ],
  },
  purchase_order: {
    sectionTitle: 'Purchase Order View',
    toolbarDateRanges: ['today', 'current_month', 'last_three_months', 'custom'],
    dateRangeOptions: [
      { value: 'today', label: 'Today' },
      { value: 'current_month', label: 'Current Month' },
      { value: 'last_three_months', label: 'Last Three Months' },
      { value: 'custom', label: 'Custom Date Range' },
    ],
  },
  sales_order: {
    sectionTitle: 'Sales Order View',
    toolbarDateRanges: ['today', 'current_month', 'last_three_months', 'custom'],
    dateRangeOptions: [
      { value: 'today', label: 'Today' },
      { value: 'current_month', label: 'Current Month' },
      { value: 'last_three_months', label: 'Last Three Months' },
      { value: 'custom', label: 'Custom Date Range' },
    ],
  },
  check_in: {
    sectionTitle: 'Vehicle Check In View',
    toolbarDateRanges: ['today', 'current_month', 'last_three_months', 'custom'],
    dateRangeOptions: [
      { value: 'today', label: 'Today' },
      { value: 'current_month', label: 'Current Month' },
      { value: 'last_three_months', label: 'Last Three Months' },
      { value: 'custom', label: 'Custom Date Range' },
    ],
  },
};

export const LIST_VIEW_SETTINGS_UPDATED_EVENT = 'listViewSettingsUpdated';

export function dispatchListViewSettingsUpdated(viewKey) {
  window.dispatchEvent(new CustomEvent(LIST_VIEW_SETTINGS_UPDATED_EVENT, { detail: { viewKey } }));
}

export function getToolbarDateRanges(viewKey, config) {
  const schema = LIST_VIEW_SCHEMAS[viewKey];
  return config?.enabled_date_ranges?.length
    ? config.enabled_date_ranges
    : schema?.toolbarDateRanges || ['today', 'current_month', 'custom'];
}
